export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="relative rounded-2xl overflow-hidden aspect-video">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20home%20theater%20setup%20with%20large%20screen%20displaying%20colorful%20movie%20scene%2C%20comfortable%20sofa%20with%20blanket%2C%20warm%20ambient%20lighting%2C%20popcorn%20bowl%20on%20wooden%20coffee%20table%2C%20modern%20minimalist%20living%20room%2C%20cinematic%20atmosphere%2C%20inviting%20and%20relaxing%20mood&width=800&height=450&seq=about-visual-01&orientation=landscape"
                alt="91电影视频平台介绍 - 舒适观影体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
            </div>
          </div>

          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3 md:mb-4 whitespace-nowrap">关于我们</span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-4 md:mb-6">91电影视频 · 你的免费私人影院</h2>

            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                91电影视频是一个专注于免费影视在线观看的综合平台，致力于为广大影迷提供最便捷、最流畅的观影体验。
                我们聚合了海量正版影视资源，覆盖电影、电视剧、综艺、动漫、纪录片等全品类内容，
                用户无需注册即可即点即播，告别繁琐流程。
              </p>
              <p>
                平台采用先进的视频分发技术，确保高清画质下流畅播放不缓冲。无论是热门院线大片、经典老片，
                还是最新热播剧集和综艺节目，91电影视频都能满足你的观影需求。我们的内容团队每日精选更新，
                让你不错过任何一部好片。
              </p>
              <p>
                自上线以来，91电影视频已累计服务超过百万用户，日均播放量突破千万次。我们始终坚持以用户为中心，
                不断优化播放体验和内容质量，立志成为华语地区最受欢迎的免费影视平台。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}